import { Launcher } from '@core/interfaces/launchers';
import { createAction, props } from '@ngrx/store';

export const setLaunchers = createAction(
  '[Launchers] set Launchers',
  props<{launchers: Launcher[]}>()
  );